import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CategoryIconRegistryApiService } from '@features/catalog/data-access/category-icon-registry-api.service';
import { TablerCategoryIconsAsset } from '@shared/utils/product-category-icon.utils';

@Injectable()
export class CatalogCategoryIconRegistryService {
  constructor(private readonly registryApi: CategoryIconRegistryApiService) {}

  load(): Observable<TablerCategoryIconsAsset> {
    return this.registryApi.load();
  }
}
